function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 5.5625L8.625 5.3125C7.375 4.78125 6 4.5 4.59375 4.5H3.5V15.5H4.59375C6.1875 15.5 7.75 15.7812 9.25 16.3125V5.5625ZM10.75 16.3125C12.25 15.7812 13.8125 15.5 15.4062 15.5H16.5V4.5H15.4062C14 4.5 12.6562 4.78125 11.375 5.3125L10.75 5.5625V16.3125ZM9.21875 3.9375L10 4.25L10.7812 3.9375C12.25 3.3125 13.8125 3 15.4062 3H16.5C17.3438 3 18 3.6875 18 4.5V15.5C18 16.3438 17.3438 17 16.5 17H15.4062C13.8125 17 12.25 17.3125 10.7812 17.9375L10.375 18.0938C10.125 18.1875 9.875 18.1875 9.625 18.0938L9.21875 17.9375C7.75 17.3125 6.1875 17 4.59375 17H3.5C2.6875 17 2 16.3438 2 15.5V4.5C2 3.6875 2.6875 3 3.5 3H4.59375C6.1875 3 7.75 3.3125 9.21875 3.9375Z",
  fill: "#006CA3"
});

function SvgIndiCoursesOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiCoursesOutline);
export default __webpack_public_path__ + "static/media/indi-courses-outline.388c0d61.svg";
export { ForwardRef as ReactComponent };